// This file is automatically generated. Do not edit manually.

import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace DeliveryActionApi {
	export async function setDeliveryToDelivered(args: { deliveryId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/setDeliveryToDelivered",
			method: "POST",
			data: {
				deliveryId: args.deliveryId,
			},
		});
		return response as void;
	}

	export async function revertDeliveryToInitial(args: { deliveryId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/revertDeliveryToInitial",
			method: "POST",
			data: {
				deliveryId: args.deliveryId,
			},
		});
		return response as void;
	}

	export async function setDeliveryToDeliveredForCargoDriver(args: { deliveryId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/setDeliveryToDeliveredForCargoDriver",
			method: "POST",
			data: {
				deliveryId: args.deliveryId,
			},
		});
		return response as void;
	}

	export async function revertDeliveryToInitialForCargoDriver(args: { deliveryId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/revertDeliveryToInitialForCargoDriver",
			method: "POST",
			data: {
				deliveryId: args.deliveryId,
			},
		});
		return response as void;
	}
}
